


export enum TileFilter {
	totalOrders = 0,
    rescheduledInbound = 1,
    rescheduledOutbound = 2,
    cancelledBeforeDelivery = 3,
    reducedBeforeDelivery = 4,
    allChangesBeforeDelivery = 5,
    totalToBeDelivered = 6,
    delivered = 7,
    onWay = 8,
    remainingAtDc = 9,
    readyToGoAtDc = 10,
    remainingToPickAtDc = 11,
    perfectlyDelivered = 12,
    notDelivered = 13,
    reducedOnDelivery = 14,
    imperfectOrdersTotal = 15,
    deliveredOnTime = 16,
    deliveredOnSmsTime = 17,
    deliveredInDeliveryWindow = 18,
    leftDepotOnTime = 19,
}


export const getTileFilterText = (tileFilter: TileFilter) => {
	switch (tileFilter) {
		case TileFilter.totalOrders: return 'Celkem objednáno';
		case TileFilter.rescheduledInbound: return 'Předatumované z předchozích dnů';
		case TileFilter.rescheduledOutbound: return 'Předatumované na další den';
		case TileFilter.cancelledBeforeDelivery: return 'Zrušené před rozvozem';
		case TileFilter.reducedBeforeDelivery: return 'Pokrácené před rozvozem';
		case TileFilter.allChangesBeforeDelivery: return 'Všechny změny před rozvozem';
		case TileFilter.totalToBeDelivered: return 'Celkem k rozvozu';
		case TileFilter.delivered: return 'Doručeno';
		case TileFilter.onWay: return 'Na cestě';
		case TileFilter.remainingAtDc: return 'Zbývá na DC';
		case TileFilter.readyToGoAtDc: return 'Vychystáno na DC';
		case TileFilter.remainingToPickAtDc: return 'Zbývá vychystat na DC';
		case TileFilter.perfectlyDelivered: return 'Perfektně doručené';
		case TileFilter.notDelivered: return 'Nedoručeno';
		case TileFilter.reducedOnDelivery: return 'Pokrácené při rozvozu';
		case TileFilter.imperfectOrdersTotal: return 'Neperfektní objednávky celkem';
		case TileFilter.deliveredOnTime: return 'Doručené přesně na čas';
		case TileFilter.deliveredOnSmsTime: return 'Doručené přesně dle SMS';
		case TileFilter.deliveredInDeliveryWindow: return 'Doručené přesně dle dodacího okna';
		case TileFilter.leftDepotOnTime: return 'Odjezdy přesně z DC';
		default: return '';
	}
}